import React, { useCallback, useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import "../content/Content.css";
import { auth } from "../../configs/firebase.config";
import apiService from "../../services/api.service";
import TopNav from "./topnav/TopNav";

const URL =
  "https://bvd2etrns3.execute-api.ap-south-1.amazonaws.com/Prod/balance";
const URL1 =
  "https://bvd2etrns3.execute-api.ap-south-1.amazonaws.com/Prod/load";
const URL2 =
  "https://bvd2etrns3.execute-api.ap-south-1.amazonaws.com/Prod/company";

import EasypayoutStmtsScreen from "./content-main/stmts/stmts.js";
import EasypayoutTransactionScreen from "./content-main/transaction/transaction.js";
import SideNaveContainer from "../side-nav/SideNaveContainer.js";
import EazyPayOutPayoutScreen from "./content-main/payout/Payout.js";
import EasyCollectStatusScreen from "./content-main/collect/CollectStatus.js";
import WithdrawScreen from "./content-main/withdraw/AdminPassDebitMasterCollectTab.js";
import LoadPayoutMasterAccountPage from "./content-main/load_main_account/LoadPayoutMasterAccountPage.js";
import PayoutSubAccountLoadScreen from "./content-main/fund_merchant/PayoutSubAccountLoadScreen.js";
import CheckStatusWithUtr from "./content-main/checkStatusWithUTR/checkStatusWithUTR.js";
import CheckStatusWithCrn from "./content-main/checkStatusWithCRN/checkStatusWithCRN.js";
import moment from "moment";
import { getUserProfile } from "../../helpers/profile_helper.js";
import Admin from "./content-main/admin/admin.js";
import EstackWalletLoadScreen from "./content-main/walletload/walletload.js";
const Content = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const Active = (path) => location.pathname === path;

  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [accountOptions, setAccountOptions] = useState({});
  const [userProfile, setUserProfile] = useState({});
  const [splash, setSplash] = useState(true);
  const [env, setEnv] = useState("");
  auth.onAuthStateChanged(function (user) {
    if (user) {
      //do nothin
    } else {
      window.recaptchaVerifier = null;
      localStorage.removeItem("user_profile");
      localStorage.removeItem("selectedCompany");
      localStorage.removeItem("selectedAccount");
      navigate("/login");
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        var user_profile = await getUserProfile();
        setUserProfile(user_profile);
        var company = Object.keys(user_profile.companyMap).sort();
        setAccountOptions(user_profile.companyMap);
        setSelectedCompany(company[0]);
        setSelectedAccount(user_profile.companyMap[company[0]].accounts[0]);
        var srcSelectedCompany = localStorage.getItem("selectedCompany");
        if (srcSelectedCompany) {
          setSelectedCompany(srcSelectedCompany);
          var srcSelectedAcount = localStorage.getItem("selectedAccount");
          if (srcSelectedAcount) {
            setSelectedAccount(srcSelectedAcount);
          }
        }
      } catch (error) {
        localStorage.removeItem("user_profile");
        console.log("%o", error);
      }
    };

    try {
      fetchData();
    } catch (error) {
      console.log("%o", error);
    }
  }, []);

  const updateselectedCompany = useCallback((company_inp) => {
    setSelectedCompany(company_inp);
  });
  const updateselectedAccount = useCallback((account_inp) => {
    setSelectedAccount(account_inp);
  });
  const Accountop = useCallback((list) => {
    setAccountOptions(list);
  });
  return (
    <div
      className={`page-interactive-screen ${!Active("/") && !Active("/login") ? "inLogin" : ""
        }`}
    >
      <div className="container_sidenave">
        <div className="sidenave">
          <SideNaveContainer
            closenav={() => {
              console.log("noneed");
            }}
          />
        </div>
      </div>
      <div className="route-contai">
        <div className="topnav">
          <TopNav
            accountOptions={accountOptions}
            env={env}
            selectedCompany={selectedCompany}
            updateCompany={updateselectedCompany}
            selectedAccount={selectedAccount}
            updateAccount={updateselectedAccount}
            Accountop={Accountop}
          />
        </div>

        <div className="routes">
          {/* {Active("/content/load")&& (
              <EasypayoutsLoadScreen selectedCompany={selectedCompany} selectedAccount={selectedAccount} apiService={apiService}/>
            )} */}
          {Active("/content/stmts") && (
            <EasypayoutStmtsScreen
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/feeAccountLoads") && (
            <EstackWalletLoadScreen
              selectedCompany={selectedCompany}
              selectedAccount={'api_client_fee_account'}
              apiService={apiService}
            />
          )}
          {Active("/content/walletloads") && (
            <EstackWalletLoadScreen
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/txn") && (
            <EasypayoutTransactionScreen
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/payout") && (
            <EazyPayOutPayoutScreen
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/collectstatus") && (
            <EasyCollectStatusScreen
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/withdraw") && (
            <WithdrawScreen
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/load_payout_master") && (
            <LoadPayoutMasterAccountPage
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/fund_merchant_account") && (
            <PayoutSubAccountLoadScreen
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/check_status_with_utr") && (
            <CheckStatusWithUtr
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/check_status_with_crn") && (
            <CheckStatusWithCrn
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
          {Active("/content/admin") && (
            <Admin
              selectedCompany={selectedCompany}
              selectedAccount={selectedAccount}
              apiService={apiService}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Content;
